import React, { Fragment } from 'react';
import { Grid, Typography, Box, Button } from '@mui/material';
import { ActionsWrapper, Paragraph, Title } from '../../pages/auth/styled';
import { useNavigate } from 'react-router-dom';

type Props = {
    validate?: any;
};

const BlockPagesIcetex = ({ validate }: Props) => {
    const navigate = useNavigate();

    return (
        <Box sx={{ width: '100%', maxWidth: 1500, margin: '0 auto' }}>
            <div className="container-icetex-form">
                <div className="container icetex-form">
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="icetex-title-form">
                                <Typography variant="h2">
                                    Página Bloqueada
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="icetex-container-form">
                        <Box sx={{ width: '100%' }}>
                            <div className="icetex-wecallyou-containter">
                                <Fragment>
                                    <Box mt={2} mb={2}>
                                        <Title variant="h4">
                                            {validate?.page}
                                        </Title>
                                        <Paragraph>
                                            {validate?.description}
                                        </Paragraph>
                                        <ActionsWrapper>
                                            <Button
                                                type="submit"
                                                className="icetex-btn-primary"
                                                onClick={() => navigate(-1)}
                                            >
                                                Volver
                                            </Button>
                                        </ActionsWrapper>
                                    </Box>
                                </Fragment>
                            </div>
                        </Box>
                    </div>
                </div>
            </div>
        </Box>
    );
};

export default BlockPagesIcetex;
